



import Vue from 'vue'
export default Vue.extend({
  name: 'GoToButton',
  props: {
    'location': {
      type: String,
      default: ''
    }
  },
  methods: {
    goTo (place:string) {
      switch (place) {
        case 'library':
          this.$router.push({ 'name': 'library' })
          break
        case 'main':
          this.$router.push({ 'name': 'main' })
          break
      }
    }
  },
  computed: {
    text () {
      switch (this.location) {
        case 'library':
          return 'Library'
        case 'app':
          return 'Go to App'
        default:
          return ''
      }
    },
    place () {
      switch (this.location) {
        case 'library':
          return 'library'
        case 'app':
          return 'main'
        default:
          return ''
      }
    }
  }
})
